export default __webpack_public_path__ + "locales/ar-SA/FormGallery.json?hash=d2ec549fa427dbf0603aa8f7131788ed";